import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"

export interface ITransactionDetail {
    _id: string
    id: string
    createdAt: Date
    updatedAt: Date
    workspaceId: string
    externalId?: string
    nf: string
}

export const transactionsDetails: IGenericModel<ITransactionDetail> = {
    ...generic(endpoints.ADMIN_TRANSACTIONS_DETAILS),
}
